var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { fetchPublisherPrefixes, getProductNumberAssignmentByProductId, } from "../api/productNumberService";
import { fetchAllAgencyPrefixes } from "../api/agencyPrefixesService";
import { fetchInternationalPrefixes } from "../api/internationalPrefixesService";
import { searchAgencyPublishers, fetchAgencyPublisherById, } from "../api/publisherService";
import { PublisherStatusEnum, InternationalPrefixAgencyEnum, } from "../types/Api";
import { hasActiveOneOffRegistration } from "../utils/publisherRegistrationUtils";
import { assignQueryRetry } from "../utils/productNumberAssignErrors";
import { usePermissions } from "./usePermissions";
import { useGetCurrentUser } from "../utils/useCurrentUser";
import { useModal } from "../utils/useModal";
export var useProductNumberAssignData = function (productId, selectedPublisherId, selectedInternationalPrefixId, selectedAgencyPrefixId, publisherQuery, internationalPrefixQuery) {
    var _a;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var _b = usePermissions(), isAgencyWorker = _b.isAgencyWorker, isPublisherRoleOnly = _b.isPublisherRoleOnly;
    var currentUser = useGetCurrentUser().data;
    var openModal = useModal().openModal;
    var _c = useState(null), previewResponse = _c[0], setPreviewResponse = _c[1];
    var _d = useQuery(["productNumberAssignment", productId], function () { return getProductNumberAssignmentByProductId(ky, productId); }, {
        enabled: !!productId,
        // Fail fast on a 4xx (e.g. 422) so the page shows an error pane instead of a
        // blank screen after react-query's default retries.
        retry: assignQueryRetry,
        onSuccess: function (data) {
            setPreviewResponse(data);
        },
    }), assignmentData = _d.data, isAssignmentError = _d.isError, assignmentError = _d.error, isAssignmentLoading = _d.isLoading;
    var publisherIdFromAssignment = assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.publisherId;
    var agency = (assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.agency) || InternationalPrefixAgencyEnum.ISBN;
    var publisherId = isAgencyWorker
        ? selectedPublisherId || publisherIdFromAssignment
        : publisherIdFromAssignment;
    var _e = useQuery(["publishers", publisherQuery], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!publisherQuery.trim()) {
                return [2 /*return*/, { items: [] }];
            }
            return [2 /*return*/, searchAgencyPublishers(ky, {
                    query: "name=\"".concat(publisherQuery.trim(), "*\" or name=\"*").concat(publisherQuery.trim(), "*\""),
                    limit: 20,
                })];
        });
    }); }, {
        enabled: isAgencyWorker && !!publisherQuery.trim(),
        staleTime: 30000,
        select: function (data) { var _a; return (_a = data.items) !== null && _a !== void 0 ? _a : []; },
    }), _f = _e.data, publishers = _f === void 0 ? [] : _f, publisherLoading = _e.isLoading;
    var publisherDetail = useQuery(["publisherDetail", publisherId], function () { return fetchAgencyPublisherById(ky, publisherId); }, {
        enabled: !!publisherId,
        staleTime: 30000,
    }).data;
    var isOneOffPublisher = hasActiveOneOffRegistration(publisherDetail, agency);
    var currentPublisherData = useMemo(function () {
        if (!publisherId)
            return null;
        if (isAgencyWorker && publishers.length > 0) {
            return (publishers.find(function (publisher) { return publisher.id === publisherId; }) || null);
        }
        return (assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.publisherName)
            ? { id: publisherId, name: assignmentData.publisherName }
            : null;
    }, [publisherId, isAgencyWorker, publishers, assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.publisherName]);
    useEffect(function () {
        var _a;
        if (assignmentData && isPublisherRoleOnly && currentUser) {
            var userPublisherId = (_a = currentUser.activeOrganization) === null || _a === void 0 ? void 0 : _a.id;
            var titlePublisherId = assignmentData.publisherId;
            if (userPublisherId !== titlePublisherId) {
                openModal(formatMessage({
                    id: "ui-br-agency.product-number.assign.error.unauthorized",
                }), function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        history.goBack();
                        return [2 /*return*/];
                    });
                }); });
            }
        }
    }, [
        assignmentData,
        isPublisherRoleOnly,
        currentUser,
        openModal,
        history,
        formatMessage,
    ]);
    var currentPublisherDataId = currentPublisherData === null || currentPublisherData === void 0 ? void 0 : currentPublisherData.id;
    useEffect(function () {
        if (!currentPublisherData || !("status" in currentPublisherData))
            return;
        var publisher = currentPublisherData;
        if (publisher.status === PublisherStatusEnum.CLOSED) {
            openModal(formatMessage({
                id: "ui-br-agency.product-number.assign.error.publisherClosed",
            }));
            return;
        }
        if (isPublisherRoleOnly && publisher.dataConfirmationTime) {
            var confirmationDate = new Date(publisher.dataConfirmationTime);
            var oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
            if (confirmationDate < oneYearAgo) {
                openModal(formatMessage({
                    id: "ui-br-agency.product-number.assign.error.confirmData",
                }), function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        history.goBack();
                        return [2 /*return*/];
                    });
                }); });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPublisherDataId, isPublisherRoleOnly]);
    // Load only the prefixes of the CHOSEN agency prefix, server-side. Previously this
    // fetched every prefix a publisher owns (limit 1000, unpaginated) and filtered by
    // agency prefix on the client, which stalled the form for publishers with many
    // prefixes (e.g. Univerzita Karlova). Gating on selectedAgencyPrefixId means nothing
    // loads until the user has picked an agency prefix, and the CQL filter keeps the
    // payload to just that agency's prefixes. Behaviour for small publishers is unchanged.
    var _g = useQuery(["publisherPrefixes", publisherId, selectedAgencyPrefixId], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!publisherId || !selectedAgencyPrefixId) {
                return [2 /*return*/, { items: [] }];
            }
            return [2 /*return*/, fetchPublisherPrefixes(ky, {
                    query: "publisher.id==\"".concat(publisherId, "\" and ") +
                        "publisherPrefixRange.agencyPrefix.id==\"".concat(selectedAgencyPrefixId, "\""),
                })];
        });
    }); }, {
        enabled: !!publisherId && !!selectedAgencyPrefixId,
        staleTime: 30000,
        select: function (data) { var _a; return (_a = data.items) !== null && _a !== void 0 ? _a : []; },
    }), _h = _g.data, publisherPrefixes = _h === void 0 ? [] : _h, publisherPrefixLoading = _g.isLoading;
    var _j = useQuery(["internationalPrefixes", internationalPrefixQuery, agency], function () { return __awaiter(void 0, void 0, void 0, function () {
        var agencyFilter;
        return __generator(this, function (_a) {
            if (!internationalPrefixQuery.trim()) {
                return [2 /*return*/, { items: [] }];
            }
            agencyFilter = agency ? " and agency==\"".concat(agency, "\"") : "";
            return [2 /*return*/, fetchInternationalPrefixes(ky, {
                    query: "value==\"*".concat(internationalPrefixQuery.trim(), "*\"").concat(agencyFilter),
                    limit: 20,
                })];
        });
    }); }, {
        enabled: !!internationalPrefixQuery.trim(),
        staleTime: 30000,
        select: function (data) { var _a; return (_a = data.items) !== null && _a !== void 0 ? _a : []; },
    }), _k = _j.data, internationalPrefixes = _k === void 0 ? [] : _k, internationalPrefixLoading = _j.isLoading;
    var _l = useQuery(["allInternationalPrefixes", agency], function () { return __awaiter(void 0, void 0, void 0, function () {
        var agencyFilter;
        return __generator(this, function (_a) {
            agencyFilter = agency ? "agency==\"".concat(agency, "\"") : "";
            return [2 /*return*/, fetchInternationalPrefixes(ky, {
                    query: agencyFilter,
                    limit: 20,
                })];
        });
    }); }, {
        enabled: !!assignmentData,
        staleTime: 30000,
        select: function (data) { var _a; return (_a = data.items) !== null && _a !== void 0 ? _a : []; },
    }).data, allInternationalPrefixes = _l === void 0 ? [] : _l;
    var _m = useQuery(["agencyPrefixes", selectedInternationalPrefixId], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!selectedInternationalPrefixId) {
                return [2 /*return*/, { items: [] }];
            }
            return [2 /*return*/, fetchAllAgencyPrefixes(ky, {
                    query: "internationalPrefix.id==\"".concat(selectedInternationalPrefixId, "\""),
                })];
        });
    }); }, {
        enabled: !!selectedInternationalPrefixId,
        staleTime: 30000,
        select: function (data) { var _a; return (_a = data.items) !== null && _a !== void 0 ? _a : []; },
    }), _o = _m.data, agencyPrefixes = _o === void 0 ? [] : _o, agencyPrefixLoading = _m.isLoading;
    return {
        assignmentData: assignmentData,
        isAssignmentLoading: isAssignmentLoading,
        isAssignmentError: isAssignmentError,
        assignmentError: assignmentError,
        assignBlockedReason: (_a = assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.assignBlockedReason) !== null && _a !== void 0 ? _a : null,
        publisherId: publisherId,
        publisherIdFromAssignment: publisherIdFromAssignment,
        agency: agency,
        isOneOffPublisher: isOneOffPublisher,
        publisherDetail: publisherDetail,
        previewResponse: previewResponse,
        setPreviewResponse: setPreviewResponse,
        publishers: publishers,
        publisherLoading: publisherLoading,
        publisherPrefixes: publisherPrefixes,
        publisherPrefixLoading: publisherPrefixLoading,
        allInternationalPrefixes: allInternationalPrefixes,
        internationalPrefixes: internationalPrefixes,
        internationalPrefixLoading: internationalPrefixLoading,
        agencyPrefixes: agencyPrefixes,
        agencyPrefixLoading: agencyPrefixLoading,
    };
};
